import { AddressInfo } from '../../../../api/generated/pm';
import { formatAddress } from '../../../../utils/addressFormat';
import { UNKNOWN_VALUE } from '../constants';
import CellText from './CellText';

export interface AddressCellProps {
  address: AddressInfo | undefined;
}

/**
 * Company address cell: country-aware "street, city, ST zip"
 * (`utils/addressFormat.ts`, per PRD 02's Table section). The country is
 * omitted because every table renders it in its own Country column. Shared by
 * Customers (02), Invites (03) and Requests (04).
 */
export default function AddressCell({ address }: AddressCellProps) {
  return <CellText text={address ? formatAddress(address) || UNKNOWN_VALUE : UNKNOWN_VALUE} />;
}
